import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import {
    firstBlockOverlapsNav,
    isOverlapBlockType,
} from "../components/HeaderNav/overlap";
import { PageSkeleton } from "../components/PageSkeleton";
import { toolboxComponents } from "../components/PageSkeleton/Toolbox";
import { UpcomingProductsBlock } from "../components/UpcomingProductsBlock";

export const Template = (props: templates.UpcomingProductsPageTemplate) => (
    <PageSkeleton
        {...props.page}
        overlapNav={firstBlockOverlapsNav(
            props.page.body.value.slice(0, 1).find(isOverlapBlockType),
        )}
    >
        <StreamField
            tagName={React.Fragment}
            value={props.page.body.value}
            components={{
                ...toolboxComponents,
                upcoming_products: ({ value }) => (
                    <UpcomingProductsBlock
                        value={value}
                        tiles={props.page.upcoming_products}
                        specSheetLinkLabel={props.page.spec_sheet_link_label}
                        subcategoryTiles={props.page.subcategory_tiles}
                        productsPageTitle={props.page.products_page_title}
                    />
                ),
            }}
        />
    </PageSkeleton>
);
